import React from 'react'
import History from "../../assets/historysnapshot.png"
import "./TotValTile.css"

function TotValTile() {
  return (

    
    <div className='totvalTile'>
    <h1 className='tile-title'>Total Asset Value</h1>
    
    <div className='chart-snapshot'>

    </div>
</div>  

)
}

export default TotValTile
